import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full border-brand-purple/15" data-id="element-403">
    <div className="flex items-center mb-4" data-id="element-404">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-purple font-serif font-bold text-sm md:text-xl border border-brand-purple/30 mr-3 md:mr-4 shrink-0 shadow-sm" data-id="element-405">
        {initials}
      </div>
      <div data-id="element-406">
        <div className="flex text-brand-gold mb-1 text-[15px]" data-id="element-407">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-408" />)}
        </div>
        <div className="font-medium text-brand-text" data-id="element-409">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-410">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px] font-serif leading-relaxed" data-id="element-411">
      "{text}"
    </p>
  </div>;
export const InitialTestimonials = () => {
  const testimonials: TestimonialProps[] = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    text: 'Nunca había tenido un péndulo en mis manos. Hoy tengo mis primeras consultas pagas y ya vendí mis primeros péndulos artesanales. Este sistema te lleva de la mano.'
  }, {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    text: 'Buscaba una forma de emprender desde casa que fuera real. En menos de 30 días estaba cobrando mis primeras sesiones.'
  }, {
    initials: 'CP',
    name: 'Carolina P.',
    location: 'La Plata',
    text: 'Lo que más me sorprendió es que en ningún momento me sentí perdida. Cada paso está explicado para alguien que empieza de cero.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-412">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px]" data-id="element-413">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-414" />)}
      </div>
    </Section>;
};
export const MoreTestimonials = () => {
  const testimonials = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    product: 'Master Kit Profesional',
    text: 'Empecé sin saber absolutamente nada. El sistema te lleva de la mano. Hoy tengo consultas pagas y ya vendí mis primeros péndulos artesanales.'
  }, {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    product: 'Emprendedor desde casa',
    text: 'Lo que más me gustó es que no es teoría. Cada módulo termina con algo que podés aplicar ese mismo día. En tres semanas ya estaba cobrando.'
  }, {
    initials: 'CP',
    name: 'Carolina P.',
    location: 'La Plata',
    product: 'Emprendedora espiritual',
    text: 'Las fichas del Legajo de Campo me hicieron ver que era una emprendedora seria. Mis primeros clientes lo notaron y me empezaron a recomendar.'
  }, {
    initials: 'RA',
    name: 'Ricardo A.',
    location: 'Mendoza',
    product: 'Emprendedor desde casa',
    text: 'El Bonus de Primeros Ingresos es lo mejor del kit. Me enseñó exactamente cuánto cobrar y cómo conseguir clientes sin publicidad paga.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-415">
      <div className="text-center mb-12" data-id="element-416">
        <h2 className="md:text-4xl font-display font-bold mb-4 text-[24px] text-brand-plum pt-[0px]" data-id="element-417">
          ❤️ MÁS PERSONAS QUE YA EMPRENDIERON DESDE CERO
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-[12px] max-w-4xl mx-auto" data-id="element-418">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-419" />)}
      </div>
    </Section>;
};